import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.replace.js";
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "tinymce"
};
import { ref, toRefs, watch, onMounted } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver/theme';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/skins/ui/oxide/content.min.css';
import 'tinymce/icons/default/icons';
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/plugins/image';
import 'tinymce/plugins/link';
import 'tinymce/plugins/table';
import 'tinymce/plugins/paste';
import './plugins/formatpainter';
import './zh_CN.js';

/* 变量 */

export default {
  __name: 'index',
  props: {
    value: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    }
  },
  emits: ['update:value'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */
    var emit = __emit;
    var props = __props;
    var _toRefs = toRefs(props),
      value = _toRefs.value,
      width = _toRefs.width,
      height = _toRefs.height;
    var initConfig = {
      // width: "100%",
      height: height.value,
      language: 'zh_CN',
      // 指定语言
      menubar: false,
      // 是否显示 菜单
      branding: false,
      // 是否显示 技术支持文案
      plugins: 'paste table formatpainter',
      statusbar: false,
      // 是否显示 底部状态栏
      content_style: "\n    body { font-family: 'Sans Regular'; }\n    p { margin: 0 0 30px 0; line-height: 1.6; word-break: break-all; }\n    img { width: 100%; }\n    .mce-offscreen-selection video { width:0 !important; }\n    table tbody, tr, td { border: 1px solid gray }\n    table tbody tr td[data-mce-selected] { background-color: #b4d7ffb3; }\n  ",
      // 内容区样式
      block_formats: 'Paragraph=p;Header 1=h1;Header 2=h2;Header 3=h3;Header 4=h4;Header 5=h5;',
      toolbar: [
      // 自定义工具栏
      'undo redo bold italic underline strikethrough fontsizeselect forecolor customSelect table bullist numlist outdent indent blockquote removeformat formatpainter customImageButton customViedoButton customLinkButton'],
      // 初始化tinymce回调
      setup: function setup(editor) {
        // 自定义下拉
        editor.ui.registry.addMenuButton('customSelect', {
          icon: 'align-justify',
          tooltip: '段落对齐',
          fetch: function fetch(callback) {
            var items = [];
            var formula = [{
              name: '左对齐',
              icon: 'align-left'
            }, {
              name: '居中对齐',
              icon: 'align-center'
            }, {
              name: '右对齐',
              icon: 'align-right'
            }, {
              name: '两端对齐',
              icon: 'align-justify'
            }];
            formula.map(function (resitem) {
              items.push({
                type: 'menuitem',
                text: resitem.name,
                icon: resitem.icon,
                onAction: function onAction(_) {
                  var cmdName = '';
                  switch (resitem.name) {
                    case '左对齐':
                      cmdName = 'JustifyLeft';
                      break;
                    case '右对齐':
                      cmdName = 'JustifyRight';
                      break;
                    case '居中对齐':
                      cmdName = 'JustifyCenter';
                      break;
                    case '两端对齐':
                      cmdName = 'JustifyFull';
                      break;
                    default:
                      break;
                  }
                  editor.execCommand(cmdName, false);
                }
              });
            });
            callback(items);
          }
        });
      },
      paste_preprocess: function paste_preprocess(plugin, args) {
        args.content = args.content.replace(/<*?(id|style|class|data-.*?)=".*?"/g, '');
        var reg = /<img(.*?)src="blob(.*?)>|<img(.*?)src="data:image(?!\/svg)(.*?)>/g;
        if (reg.test(args.content)) {
          args.content = args.content.replace(reg, '');
          MessagePlugin.warning('暂不支持粘贴屏幕截图！');
        }
      }
    };
    var tinymceHtml = ref('');

    /* 监听 */
    watch(tinymceHtml, function (val) {
      emit('update:value', val);
    });
    watch(value, function (val) {
      tinymceHtml.value = val;
    }, {
      immediate: true
    });

    /* 钩子 */
    onMounted(function () {
      tinymce.init({});
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Editor), {
        id: "tinymce",
        modelValue: tinymceHtml.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return tinymceHtml.value = $event;
        }),
        init: initConfig
      }, null, 8, ["modelValue"])]);
    };
  }
};